module.exports = __webpack_public_path__ + "static/media/preview.bce4b25e.png";